package com.siriusxm.pia.operations.components

import com.siriusxm.pia.SXMUI
import org.jetbrains.compose.web.css.*

/**
 * Stylesheet for operations UI components including logs and monitors.
 *
 * Uses SXMUI color system for consistent styling across the application.
 * Colors are based on severity levels and monitor states.
 */
object OperationsStyles : StyleSheet() {

    // Log severity styles
    val logListError by style {
        backgroundColor(SXMUI.messageAlertBackground.value())
    }

    val logListWarning by style {
        backgroundColor(SXMUI.messageWarnBackground.value())
    }

    val logListInfo by style {}

    val logListItem by style {
        padding(3.px, 5.px)
    }

    val logListItemContext by style {
        fontSize(0.8.em)
        color(SXMUI.subtleTextColor.value())
    }

    val logListItemMessage by style {
        whiteSpace("pre-wrap")
        property("word-break", "break-word")
    }

    val logDetailView by style {
        padding(10.px)
        backgroundColor(SXMUI.mainLayoutBackgroundColor.value())
        fontSize(0.85.em)
        fontFamily("monospace")
        whiteSpace("pre-wrap")
        overflow("auto")
        maxHeight(300.px)
    }

    // Monitor styles - colors match DataDog status indicators
    val monitorStatusOk by style {
        backgroundColor(Color("#4caf50"))
    }

    val monitorStatusAlert by style {
        backgroundColor(Color("#f44336"))
    }

    val monitorStatusWarn by style {
        backgroundColor(Color("#ff9800"))
    }

    val monitorStatusNoData by style {
        backgroundColor(Color("#9e9e9e"))
    }

    val monitorStatusIndicator by style {
        width(10.px)
        height(10.px)
        borderRadius(50.percent)
        display(DisplayStyle.InlineBlock)
    }

    val monitorCard by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        padding(8.px, 12.px)
    }

    val monitorName by style {
        flex(1)
    }

    val monitorPriority by style {
        fontSize(0.75.em)
        padding(2.px, 6.px)
        borderRadius(4.px)
        backgroundColor(SXMUI.containerHeaderBackgroundColor.value())
    }

    val monitorsGrid by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(4.px)
    }

    val logsViewerControls by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        gap(10.px)
        marginBottom(10.px)
    }

    val logsViewerFilters by style {
        display(DisplayStyle.Flex)
        gap(10.px)
        alignItems(AlignItems.Center)
    }
}
